import { Flex, Text } from "@mantine/core";

interface UserDetailsProps {
  title: string;
  detail?: string | null;
}

export function UserDetails({ title, detail }: UserDetailsProps) {
  return (
    <Flex hidden={!detail} justify="space-between">
      <Text span className="text-xl text-primary-text-subtle">
        {title}
      </Text>
      <Text span className="text-xl font-medium text-primary-text-body">
        {detail}
      </Text>
    </Flex>
  );
}
